import React, { Component } from 'react';
import { api } from '../api/index.js';
import EditIssue from './EditIssue';
// import CreateIssue from './CreateIssue';


class NewIssue extends Component {

    constructor() {
        super();

        this.state = {
            issues: [],
            creatingIssue: false,
            isSaving: false,
            saveFailed: false,
            saveSuccess: false,
            formControls: []  // dynamic form definitions
        };

        this.handleEnableAddMode = this.handleEnableAddMode.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
    }

    componentDidMount() {
        // Load customer-specific form controls, falling back to global manifest
        api.configurations.getCustomerFields()
                        .then(response => {
                const controls = response.selectedFields || [];
                console.log('Loaded customer fields:', controls);
                console.log('Sample field with enabled status:', controls[0]);
                console.log('Enabled status breakdown:', controls.map(c => ({ name: c.name, enabled: c.enabled })));

                // Filter to only enabled controls
                const enabledControls = controls.filter(control => control.enabled === true);
                const disabledControls = controls.filter(control => control.enabled === false);

                console.log('Enabled controls count:', enabledControls.length);
                console.log('Disabled controls count:', disabledControls.length);
                console.log('Enabled control names:', enabledControls.map(c => c.name));
                console.log('Disabled control names:', disabledControls.map(c => c.name));

                this.setState({ formControls: enabledControls });
            })
            .catch(err => {
                console.error('Error loading customer fields, falling back to global:', err);
                api.configurations.getFormControls()
                                        .then(resp => {
                        const controls = resp.formControls || [];
                        console.log('Loaded global fields:', controls);
                        console.log('Sample global field with enabled status:', controls[0]);
                        console.log('Global enabled status breakdown:', controls.map(c => ({ name: c.name, enabled: c.enabled })));

                        // Filter to only enabled controls
                        const enabledControls = controls.filter(control => control.enabled === true);
                        const disabledControls = controls.filter(control => control.enabled === false);

                        console.log('Global enabled controls count:', enabledControls.length);
                        console.log('Global disabled controls count:', disabledControls.length);
                        console.log('Global enabled control names:', enabledControls.map(c => c.name));
                        console.log('Global disabled control names:', disabledControls.map(c => c.name));

                        this.setState({ formControls: enabledControls });
                    })
                    .catch(err2 => {
                        console.error('Error loading global fields:', err2);
                        this.setState({ formControls: [] });
                    });
            });
    }

    handleSelect(issue) {
        this.setState({ selectedIssue: issue });
    }

    handleDelete(event, issue) {
        event.stopPropagation();

        // Use the new API for deleting issues
        api.issues.delete(issue.id)
            .then(() => {
                let issues = this.state.issues;
                issues = issues.filter(h => h !== issue);
                this.setState({ issues: issues });

                if (this.selectedIssue === issue) {
                    this.setState({ selectedIssue: null });
                }
            })
            .catch(err => {
                console.error('Error deleting issue:', err);
            });
    }

    handleEnableAddMode() {
        // Date + Math Random results in a limited amount of possible ids each day
        const id = parseInt(new Date().getDay() + '' + new Date().getMonth() + '' + Math.floor(Math.random() * 132547698), 10);
        this.setState({
            addingIssue: true,
            selectedIssue: {
                id: id,
                address: '',
                worktype: '',
                email: '',
                image: '',
                name: '',
                phone: '',
                description: '',
            }
        });
    }

    handleCancel() {
        this.setState({ addingIssue: false, selectedIssue: null });
    }

    handleSave() {
        let issues = this.state.issues;

        this.setState({ isSaving: true });

        if (this.state.addingIssue) {
            // Use the new API for creating issues
            api.issues.create(this.state.selectedIssue)
                .then(result => {
                    console.log('Successfully created issue:', result);

                    issues.push(this.state.selectedIssue);
                    this.setState({
                        issues: issues,
                        selectedIssue: null,
                        addingIssue: false,
                        isSaving: false,
                        saveFailed: false,
                        saveSuccess: true
                    });
                })
                .catch(err => {
                    console.error('Error creating issue:', err);
                    this.setState({
                        addingIssue: false,
                        isSaving: false,
                        saveFailed: true
                    });
                });
        } else {
            // Use the new API for updating issues
            api.issues.update(this.state.selectedIssue.id, this.state.selectedIssue)
                .then(() => {
                    console.log('Successfully updated issue');
                    this.setState({
                        selectedIssue: null,
                        isSaving: false,
                        saveFailed: false,
                        saveSuccess: true
                    });
                })
                .catch(err => {
                    console.error('Error updating issue:', err);
                    this.setState({
                        isSaving: false,
                        saveFailed: true
                    });
                });
        }
    }

    handleOnChange(event) {
        let selectedIssue = this.state.selectedIssue;
        let value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;

        if (event.target.type === 'file') {
            const file = event.target.files[0];

            // Check if a file was actually selected
            if (!file) {
                // If no file selected, clear the image
                this.setState({ selectedIssue: { ...this.state.selectedIssue, image: '' } });
                return;
            }

            const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];

            if (!allowedTypes.includes(file.type)) {
                alert('Please upload a file of type .jpeg, .jpg, or .png');
                // Clear the file input
                event.target.value = '';
                return;
            }

            // Check file size (limit to 5MB)
            const maxSize = 5 * 1024 * 1024; // 5MB in bytes
            if (file.size > maxSize) {
                alert('File size must be less than 5MB');
                event.target.value = '';
                return;
            }

            // Create a new FileReader for this file to avoid potential conflicts
            const fileReader = new FileReader();

            fileReader.onloadend = () => {
                try {
                    // The result includes the full data URL (e.g., "data:image/jpeg;base64,/9j/4AAQ...")
                    // We need to extract just the base64 part after the comma
                    const base64Data = fileReader.result.split(',')[1];

                    if (base64Data) {
                        // Store base64 data directly without URL encoding to prevent corruption
                        this.setState({
                            selectedIssue: {
                                ...this.state.selectedIssue,
                                image: base64Data
                            }
                        });
                        console.log('Image successfully converted to base64');
                    } else {
                        console.error('Failed to extract base64 data from file');
                        alert('Failed to process the image. Please try again.');
                        event.target.value = '';
                    }
                } catch (error) {
                    console.error('Error processing image:', error);
                    alert('Failed to process the image. Please try again.');
                    event.target.value = '';
                }
            };

            fileReader.onerror = () => {
                console.error('Error reading file:', fileReader.error);
                alert('Failed to read the image file. Please try again.');
                event.target.value = '';
            };

            // Start reading the file as data URL
            fileReader.readAsDataURL(file);
        } else {
            selectedIssue[event.target.name] = value;
            this.setState({ selectedIssue: selectedIssue });
        }
    }

    render() {
        return (
            <div className="container p-4">
                <h1 className="my-4">Report An Issue</h1>
                <p className='mb-4'>
                    Please provide relevant information.
                    The more accurate and specific you are, the faster we can resolve the problem.
                    Use the form below to submit your report.
                </p>
                <div className="editarea mt-4">
                    {
                        this.state.addingIssue && !this.state.isSaving ?
                            <EditIssue
                                addingIssue={this.state.addingIssue}
                                onChange={this.handleOnChange}
                                selectedIssue={this.state.selectedIssue}
                                onSave={this.handleSave}
                                onCancel={this.handleCancel}
                                formControls={this.state.formControls}  // pass dynamic controls
                            />
                            :
                            <button className='btn btn-dark w-100 my-4' onClick={this.handleEnableAddMode}>Create New Issue</button>
                    }
                    {
                        this.state.saveSuccess ?
                            <div className="alert alert-success" role="alert">
                                Issue saved successfully. You can now track the status of your request by searching for it using your email address in the Search tab.
                            </div>
                            : null
                    }
                    {
                        this.state.isSaving ?
                            <div className="alert alert-primary" role="alert">
                                Saving...
                            </div>
                            : null
                    }
                    {
                        this.state.saveFailed ?
                            <div className="alert alert-danger" role="alert">
                                Save failed. Please try again.
                            </div>
                            : null
                    }
                </div>
            </div>
        );
    }
}


export default NewIssue;